export const datepickerConfig = {
  colorScheme: {
    light: {},
  },
  css: () => `
    .p-datepicker-input.p-inputtext {
      border: 0;
      padding-inline: 0;
      box-shadow: none;
      background-color: transparent;
      &:focus, &:hover {
        border: 0;
      }
    }
    .p-datepicker.date-time-picker .p-datepicker-clear-icon {
      position: static;
      margin: 0 0 0 3px;
    }
    .p-datepicker {
      align-items: center;
      &:not(.date-time-picker) {
        flex: 1;
      }
    }
    .p-datepicker-time-picker {
      display: none
    }
    .p-datepicker-header {
      p-button {
        width: fit-content;
      }
    }
  `,
};
